import { SettingsService } from "../../api/settings-service";
import { EOSService } from "../../api/eos-service";
import Result from "../../model/result";

const initialState = () => {
    return {
        settings: {},
        VacationBudgeCount: '',
        MissionBudgeCount: '',
        IOBudgeCount: '',
        ExtraWorkBudgeCount: '',
        ExtraWorkManagementBudgeCount: '',
        disableSideMenu:false
    }
}
const state = initialState()

const getters = {
    VacationBudgeCount: (state) => state.VacationBudgeCount,
    MissionBudgeCount: (state) => state.MissionBudgeCount,
    IOBudgeCount: (state) => state.IOBudgeCount,
    ExtraWorkBudgeCount: (state) => state.ExtraWorkBudgeCount,
    ExtraWorkManagementBudgeCount: (state) => state.ExtraWorkManagementBudgeCount,
};

const actions = {
    async readwebkartsetting({ commit }) {
        /*var settings = state.settings;
        if (settings != {}) {
            return Result.success(settings)
        }*/

        return await SettingsService.readwebkartsetting().then((response) => {
            var data = response.data
            if (data.ResponseResultType === 1) {
                commit('setSettings', data.Values);
                return Result.success(data.Values)
            } else {
                return Result.error(data.Message)
            }
        })
    },
    async IsActvieSecurity() {
        return await EOSService.makeRequest(SettingsService.IsActvieSecurity())
    },
    async readSystemTable() {
        return await EOSService.makeRequest(SettingsService.readSystemTable())
    },
    async getClockSelection() {
        return await EOSService.makeRequest(SettingsService.getClockSelection())
    },
    async VacationUseWorkCalendar() {
        return await EOSService.makeRequest(SettingsService.VacationUseWorkCalendar())
    },
    async GetAlarmExpire(context, { perno }) {
        var params = new URLSearchParams()
        params.append('perno', perno)
        return await EOSService.makeRequest(SettingsService.GetAlarmExpire(params))
    },
    async GetAllStateForAdmin(context) {
        let callback = function (response) {
            if (response?.data) {
                var data = response.data
                //debugger
                if (data.ResponseResultType === 1) {
                    let res = data.Values;
                    context.commit('setVacationBudgeCount', res.VactionNum)
                    context.commit('setMissionBudgeCount', res.MissionNum)
                    context.commit('setIOBudgeCount', res.IoNum)
                    context.commit('setExtraWorkBudgeCount', res.EwNum)
                    context.commit('setExtraWorkManagementBudgeCount', res.SpecificEwNum)
                }
            }
        }
        var params = new URLSearchParams();
        var perno = context.rootState.auth.auth.username;
        var activeDirectory=localStorage.getItem('userActive')
        if(activeDirectory){
            debugger
            params.append('perno', perno);
        }
        else{
            params.append('perno', perno);
        }
        
        return await EOSService.makeRequest(SettingsService.GetAllStateForAdmin(params), callback)
    },
    async WriteSystemTable(context, { misTransfer, morTransfer }) {
        var params = new URLSearchParams()
        params.append('misTransfer', misTransfer)
        params.append('morTransfer', morTransfer)
        return await EOSService.makeRequest(SettingsService.WriteSystemTable(params))
    },
    async AddDefaultCity(context, { citycode }) {
        var params = new URLSearchParams()
        params.append('citycode', citycode)
        return await EOSService.makeRequest(SettingsService.AddDefaultCity(params))
    },
    async UpdateEventFlag(context, { showEvent }) {
        var params = new URLSearchParams()
        params.append('showEvent', showEvent)
        return await EOSService.makeRequest(SettingsService.UpdateEventFlag(params))
    },
    async UpdateBirthDayFlag(context, { birthDayFlag }) {
        var params = new URLSearchParams()
        params.append('showEvent', birthDayFlag)
        return await EOSService.makeRequest(SettingsService.UpdateBirthDayFlag(params))
    },
    async UpdateAllowIoInCurrentDay(context, { allow }) {
        var params = new URLSearchParams()
        params.append('allow', allow)
        return await EOSService.makeRequest(SettingsService.UpdateAllowIoInCurrentDay(params))
    },
    async UpdateClock(context, { UpdateClockAllowSelect }) {
        var params = new URLSearchParams()
        params.append('allowSelect', UpdateClockAllowSelect)
        return await EOSService.makeRequest(SettingsService.UpdateClock(params))
    },
    async updateVacationCalendar(context, { isWorkCalendar }) {
        var params = new URLSearchParams()
        params.append('isWorkCalendar', isWorkCalendar)
        return await EOSService.makeRequest(SettingsService.updateVacationCalendar(params))
    },
    async AddApproveMission(context, { missionCode }) {
        var params = new URLSearchParams()
        params.append('missionCode', missionCode)
        return await EOSService.makeRequest(SettingsService.AddApproveMission(params))
    },
    async SetWebVacations(context, { vacationCode }) {
       
        return await EOSService.makeRequest(SettingsService.SetWebVacations(vacationCode))
    },
    async SetWebMissions(context, { missionCode }) {
       
        return await EOSService.makeRequest(SettingsService.SetWebMissions(missionCode))
    },
    async TruncateApprovedMission() {
        return await EOSService.makeRequest(SettingsService.TruncateApprovedMission())
    },
    async TruncateApprovedVacation() {
        return await EOSService.makeRequest(SettingsService.TruncateApprovedVacation())
    },
    async UpdateLimitationDays(context, { UpdateLimitationDaysData }) {
        var data = new URLSearchParams()
        data.append('vacationPreDay', UpdateLimitationDaysData.vacationPreDay)
        data.append('vacationEndDay', UpdateLimitationDaysData.vacationEndDay)
        data.append('ioEndDay', UpdateLimitationDaysData.ioEndDay)
        data.append('enableAfterEmployee', UpdateLimitationDaysData.enableAfterEmployee)
        data.append('maxMorInDay', UpdateLimitationDaysData.maxMorInDay)
        data.append('motanavebDay', UpdateLimitationDaysData.motanavebDay)
        data.append('motavaliDay', UpdateLimitationDaysData.motavaliDay)
        data.append('maxIoRequestInPeriod', UpdateLimitationDaysData.maxIoRequestInPeriod)
        data.append('maxMorInPeriod', UpdateLimitationDaysData.maxMorInPeriod)
        data.append('missionPreday', UpdateLimitationDaysData.missionPreday)
        data.append('missionNextDay', UpdateLimitationDaysData.missionNextDay)
        data.append('extraworkPreDay', UpdateLimitationDaysData.extraworkPreDay)
        data.append('extraWorkNextDay', UpdateLimitationDaysData.extraWorkNextDay)
        data.append('maxVacation', UpdateLimitationDaysData.maxVacation)
        data.append('ewStatusAfterDeadLine', UpdateLimitationDaysData.ewStatusAfterDeadLine)
        data.append('ioStatusAfterDeadLine', UpdateLimitationDaysData.ioStatusAfterDeadLine)
        data.append('vacStatusAfterDeadLine', UpdateLimitationDaysData.vacStatusAfterDeadLine)
        data.append('misStatusAfterDeadLine', UpdateLimitationDaysData.misStatusAfterDeadLine)
        data.append('deadLineConfirmExtraWork', UpdateLimitationDaysData.deadLineConfirmExtraWork)
        data.append('deadLineConfirmIo', UpdateLimitationDaysData.deadLineConfirmIo)
        data.append('deadLineConfirmVacation', UpdateLimitationDaysData.deadLineConfirmVacation)
        data.append('deadLineConfirmMission', UpdateLimitationDaysData.deadLineConfirmMission)
        data.append('missionCount', UpdateLimitationDaysData.missionCount)
        data.append('vacationCount', UpdateLimitationDaysData.vacationCount)
        data.append('teloranceForBeginTimeVacation', UpdateLimitationDaysData.teloranceForBeginTimeVacation)
        data.append('teloranceForBeginTimeMission', UpdateLimitationDaysData.teloranceForBeginTimeMission)
        data.append('limitOnTimmingMissionLength', UpdateLimitationDaysData.limitOnTimmingMissionLength)
        data.append('maxMisInDay', UpdateLimitationDaysData.maxMisInDay)
        data.append('beginTimeVacationCount', UpdateLimitationDaysData.beginTimeVacationCount)
        data.append('beginTimeMissionCount', UpdateLimitationDaysData.beginTimeMissionCount)

        return await EOSService.makeRequest(SettingsService.UpdateLimitationDays(data))
    },

    async UpdateSomeAddedField(context, { UpdateSomeAddedFieldData }) {
        var data = new URLSearchParams()
        data.append('canNotAddMorInHoliday', UpdateSomeAddedFieldData.canNotAddMorInHoliday)
        data.append('canNotAddMorAfterHoliday', UpdateSomeAddedFieldData.canNotAddMorAfterHoliday)
        data.append('disableLeftMor', UpdateSomeAddedFieldData.disableLeftMor)
        data.append('saveMissionTime', UpdateSomeAddedFieldData.saveMissionTime)
        data.append('commentRequired', UpdateSomeAddedFieldData.commentRequired)
        data.append('commentRequiredForExtraWork', UpdateSomeAddedFieldData.commentRequiredForExtraWork)
        data.append('commentRequiredForVacation', UpdateSomeAddedFieldData.commentRequiredForVacation)
        data.append('commentRequiredForIo', UpdateSomeAddedFieldData.commentRequiredForIo)
        data.append('inBeginTimeVacation', UpdateSomeAddedFieldData.inBeginTimeVacation)
        data.append('inBeginTimeMission', UpdateSomeAddedFieldData.inBeginTimeMission)
        data.append('checkIoInVacation', UpdateSomeAddedFieldData.checkIoInVacation)
        data.append('checkIoInMission', UpdateSomeAddedFieldData.checkIoInMission)
        data.append('limitForOrdinaryVacation', UpdateSomeAddedFieldData.limitForOrdinaryVacation)
        data.append('maxhourlyVacationPerYear', UpdateSomeAddedFieldData.maxhourlyVacationPerYear)
        data.append('checkBeginTimeVacationForNextDays', UpdateSomeAddedFieldData.checkBeginTimeVacationForNextDays)
        data.append('checkBeginTimeMissionForNextDays', UpdateSomeAddedFieldData.checkBeginTimeMissionForNextDays)
        data.append('AutoAcceptGeoIo', UpdateSomeAddedFieldData.AutoAcceptGeoIo)

        return await EOSService.makeRequest(SettingsService.UpdateSomeAddedField(data))
    },

    async UpdateportalAccess(context, { UpdateportalAccessData }) {
        var data = new URLSearchParams()
        data.append('portalAccessUserName', UpdateportalAccessData.portalAccessUserName)
        data.append('portalAccessPassword', UpdateportalAccessData.portalAccessPassword)
        data.append('portalHomePage', UpdateportalAccessData.portalHomePage)
        data.append('portalErrorPage', UpdateportalAccessData.portalErrorPage)
        data.append('logoutMode', UpdateportalAccessData.logoutMode)

        return await EOSService.makeRequest(SettingsService.UpdateportalAccess(data))
    },

    async SetActiveDirectory(context, { activeDirectoryName }) {
        var params = new URLSearchParams()
        params.append('activeDirectoryName', activeDirectoryName)

        return await EOSService.makeRequest(SettingsService.SetActiveDirectory(params))
    },
    async CheckConfiremReqestDeadLine() {
        return await EOSService.makeRequest(SettingsService.CheckConfiremReqestDeadLine())
    },
    async GetAlertBirthDay() {
        return await EOSService.makeRequest(SettingsService.GetAlertBirthDay())
    },
};

const mutations = {
    setDisableSideMenu: (state, disableSideMenu) => (state.disableSideMenu = disableSideMenu),
    setSettings: (state, settings) => (state.settings = settings),
    setVacationBudgeCount: (state, count) => (state.VacationBudgeCount = count),
    setMissionBudgeCount: (state, count) => (state.MissionBudgeCount = count),
    setIOBudgeCount: (state, count) => (state.IOBudgeCount = count),
    setExtraWorkBudgeCount: (state, count) => (state.ExtraWorkBudgeCount = count),
    setExtraWorkManagementBudgeCount: (state, count) => (state.ExtraWorkManagementBudgeCount = count),
    resetState(state) {
        Object.assign(state, initialState())
        //console.log('resetState');
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}